export default "__VITE_ASSET__DlFqWEb4__"